/* global globalThis */
import { gameStorage } from "./gameIdentity.js";
export const CONSENT_RECEIPT_UNAVAILABLE_NOTICE =
    "The secure consent receipt could not be verified. No research contribution has been enabled. Retry, or choose Play without research contribution.";

export const getConsentEntryOutcome = ({ receiptVerified = false, researchAccessAvailable = false } = {}) => {
    if (receiptVerified === true && researchAccessAvailable === true) {
        return {
            mode: "research-consent",
            shouldUnlock: true,
            status: "RECORDED",
            notice: "",
        };
    }

    return {
        mode: "locked",
        shouldUnlock: false,
        status: "NOT RECORDED",
        notice: CONSENT_RECEIPT_UNAVAILABLE_NOTICE,
    };
};

export const preparePostConsentIdentitySelection = (targetStorage = gameStorage) => {
    if (!targetStorage) return false;
    try {
        targetStorage.setItem("pure_identity_type", "anonymous");
        targetStorage.setItem("pure_active_game", "HOME");
        return true;
    } catch {
        return false;
    }
};
